import React, { useState } from "react";
import { Switch, Route } from "react-router-dom";
import PublicRoutes from "./PublicRoutes";
import PrivateRoutes from "./PrivateRoutes";
import { RoutesType } from "../commonTypes/routesType";
import {
  Login,
  ForgotPassword,
  Home,
  Services,
  IFSC,
  BankAccountInfo,
  GstInfo,
  PanVerify,
  TanVerify,
  PanAadharLink,
  Settings,
  AllUsersAndClients,
  AssignColumns,
  AssignColumnsNew,
  AssignClients,
  AddInvoice,
  InvoiceListings,
  EditInvoice,
  ChangeClientPassword,
  DocumentList,
  ClientDashboard,
  JobTrackerListing,
  BulkUpload,
  InvoiceBulkUpload,
  SupportPage,
  AdminOpenItemsList,
  ClientOpenItemsList,
  ClientViewOpenItem,
  FileManager,
  InsightsDashboard,
  AdminOpenItemAdd,
  InvoiceDetail,
  AdminOpenItemSummary,
  AdminOpenItemEdit,
  AdminReports,
  JobProgressReports,
  InvoiceGenerationList,
  InvoiceGenerationAdd,
  AddEditOtherEntryInvoice,
  ClientSettings,
  AddressManager,
  CustomerSupplierManager,
  AddCustomerSupplier,
  EditCustomerSupplier,
  AddBusinessAddress,
  EditBusinessAddress,
  AccountsManager,
  InvoiceGenerationEditInvoice,
  UserOpenJobsListing,
  OpenItemsProgressReports,
  Reports,
  LedgerStatement,
  TrialBalance,
  ProfitLoss,
  BalanceSheet,
  StockManager,
  StockGroupsList,
  StockItemsList,
  AddStockItem,
  UnitsOfMeasurement,
  UserManagement,
  UserGroups,
  AddEditUserGroup,
  FileFolderCounterReports,
  InvoicingAdvanceCounts,
  InsightsAdvacedList,
  EditStockItemList,
  ResetForgetPassword,
  ErrorPage,
  AddEditMenuList,
  // UserProfile,
  Unauthorize,
  StockReportSummary,
  StockStatement,
  AddIdPasswordManager,
  IdPasswordManagerList,
  EditIdPasswordManager,
  ScheduleMaintenance,
  ClientIdPasswordManagerList,
  AddIClientIdPasswordManager,
  EditClientIdPasswordManager,
  AssignGroupToUser,
  AssignGroupsList,
  DisbursementModuleList,
  AddDisbursement,
  EditDisbursement,
  // AddUser,
  // UserProfileEdit,
  AssignedUsersOfClient,
  ViewOpenItemsProgressReports,
  GSTModule,
  GstrOne,
  AddInternalExternalUser,
  EditInternalExternalUser,
  ClientDirectory,
  EditClient,
  MasterData,
  Branch,
  Currency,
  ActivityCode,
  TimeSheet,
  GstrThreeB,
  AddClient,
  Jobs,
  JobsType,
  RecurringJobsSetting,
  AddJobType,
  EditJobType,
  CopyInvoice,
  OtherCopyInvoice,
  JobsList,
  AddJobs,
  EditJobs,
  ComplianceCalendar,
  LeadModule,
  DetailedProfitLoss,
  EditLeadModule,
  AddRecurringJobsSetting,
  EditRecurringJobsSetting,
  HelpModule,
  DetailedBalanceSheet,
  Scheduling,
  UserView,
  ManagerView,
  RequestView,
  ClientGroup,
  UserLoginSessionReport,
  DailyActiveUser,
  MonthlyActiveUser,
  UserSessionLoginCount,
  UserReport,
  InsightSummary,
  AllUsersSchedule,
  AllClientsSchedule,
  SchedulingReports,
  InvoiceReports,
  UsersInvoicingCount,
  AllUsersApprovalPendingList,
  ManagerClientSchedule,
  DayBook,
  SearchFileManager,
  TimeSheetAdminReport,
  TimeSheetReports,
  TimSheetSummaryReport,
  GeneralLedger,
  ViewClient,
  ClientVsUserScheduling,
  Email,
  CostOfGoods,
  ClientJobSchedule,
  FixedAssetRegister,
  AddEditFixedAssetRegister,
  HolidayCalender,
  Department,
  FixedAssetBulkUpload,
  PhysicalVerification,
  AuditSession,
  AddAuditSession,
  AllEInvoiceList,
  AllEwayBillList,
  // Scheduling
  AllUserAttendanceReport,
  AttendanceReport,
  JobSpecificUsersReport,
  ClientCategory,
  PhysicalVerificationIdentity,
  FixedAssetRegisterList,
  UsersDepartment,
  AddBillOfMaterial,
  EditBillOfMaterial,
  MySpace,
  LoggedInUserProfileDetails,
  LoggedInUsersAttendanceReport,
  AllLeavesAndWHF,
  BOMSavedTemplate,
  TimeSheetVsSchedulingMonthlyReport,
  AgeingAnalysisReport,
  ApprovedAndPendingLeaves,
  LeaveAndWFHDetails,
  HMRMS,
  DetailedTrialBalance,
  HRDashboard,
  RecruitmentModule,
  OpenPosition,
  RecruitmentTracker,
  RecruitmentTrackerBulkUpload,
  AddRecruitmentTracker,
  EditRecruitmentTracker,
  HiringCheckList,
  SopModule,
  EditSopModule,
  AddSopModule,
  ClientMeetUp,
  LeadDirectory,
  ThinksToDo,
  // AllInterviewList,
  EditClientMeetUp,
  AllClientMeetUpStatus,
  ApprovedAndPendingWFH,
  AddTdsMaster,
  EditTdsMaster,
  CheckInScheduleList,
  TeamDirectory,
  TimeSheetClientWiseUserReport,
  AllUsersCheckInsReports,
  ScopeOfWork,
  SkillsAndQualification,
  TdsAndTcsMaster,
  AddTcsMaster,
  EditTcsMaster,
  InterviewAndApprovalPendingList,
  ReceiptAndPayment,
  JobChecklist,
  EditJobChecklist,
  AddJobChecklist,
  AddPEForm,
  PerformanceEvaluationList,
  AllUserPerformanceEvaluationReport,
  AllClientSop,
  AllOpenJobChecklist,
  GstOneFiling,
  AllUsersLeaveHistoryReport,
  GstThreeBFiling,
  TimesheetClientWiseMonthlyReport,
  TimesheetMonthWiseClientReport,
  GeneralSetting,
  PdfTemplateMaster,
  AllUsersRatingReport,
  RaiseExpenseHome,
  ExpenseManagement,
  ApproveExepnseHome,
  GSTRSteps,
  Einvoice,
  EinvoiceSteps,
  EwayBill,
  EwayBillSteps,
  StockLimits,
  RecurringJobReport,
  AddOcrInvoice,
  PricingCalculator,
  AllClientLockDateList,
  AllExternalUserEmailers,
  LeadModuleStageThresholdMaster,
  SignUp,
  AllUserApprovedEntry,
  BulkUploadReport,
  CustomerSupplierBulkUpload,
  StockItemBulkUpload,
  GovermentDirectory,
  ViewAllMappedJobs,
  AddGstCompareInvoice,
  BatchManagement,
  AddBatchManagement,
  EditBatchManagement,
  BatchSummaryReport,
  AuSignUp,
  BatchVoucherReport,
  AvailabilityReport,
  MonthlyLedgerSummary,
  JobTitle,
  UserWiseOCRReport,
  ClientWiseOCRReport,
} from "../screens";
import HybridRoute from "./HybridRoute";

type AppProps = {
  routes: RoutesType[];
  token: string | null;
};

const ROUTES = [
  {
    path: "/team-directory",
    key: "Team Directory",
    component: TeamDirectory,
    isPrivate: true,
    exact: true,
  },

  {
    path: "/officer-directory",
    key: "Officer's Directory",
    component: GovermentDirectory,
    isPrivate: true,
    exact: true,
  },

  {
    path: "/officer-directory/view-all-mapped-jobs/:userId",
    key: "User Mapped Jobs",
    component: ViewAllMappedJobs,
    isPrivate: true,
    exact: true,
  },

  {
    path: "/admin-reports/all-client-lock-date",
    key: "All Client Lock Date",
    component: AllClientLockDateList,
    isPrivate: true,
    exact: true,
  },

  {
    path: "/admin-reports/emailer-template",
    key: "All Emailer Template",
    component: AllExternalUserEmailers,
    isPrivate: true,
    exact: true,
  },

  {
    path: "/admin-reports/all-user-approved-entry",
    key: "All User Approved Entry",
    component: AllUserApprovedEntry,
    isPrivate: true,
    exact: true,
  },

  {
    path: "/admin-reports/all-bulk-upload-report",
    key: "All Bulk Upload Report",
    component: BulkUploadReport,
    isPrivate: true,
    exact: true,
  },
  {
    path: "/admin-reports/user-wise-ocr-report",
    key: "User Wise OCR Report",
    component: UserWiseOCRReport,
    isPrivate: true,
    exact: true,
  },
  {
    path: "/admin-reports/client-wise-ocr-report",
    key: "Client Wise OCR Report",
    component: ClientWiseOCRReport,
    isPrivate: true,
    exact: true,
  },
  {
    path: "/gstr-steps",
    key: "gstr step",
    component: GSTRSteps,
    isPrivate: true,
    exact: true,
  },
  {
    path: "/einvoice-steps",
    key: "envoice steps",
    component: EinvoiceSteps,
    isPrivate: true,
    exact: true,
  },
  {
    path: "/pricing",
    key: "pricing",
    component: PricingCalculator,
    isPrivate: null,
    exact: true,
  },
  {
    path: "/eway-bill-steps",
    key: "eway bill steps",
    component: EwayBillSteps,
    isPrivate: true,
    exact: true,
  },
  {
    path: "/client-settings/general-setting/:id",
    key: "General Setting",
    component: GeneralSetting,
    isPrivate: true,
    exact: true,
  },
  {
    path: "/master-data/invoice-templates",
    key: "pdf templates",
    component: PdfTemplateMaster,
    isPrivate: true,
    exact: true,
  },
  {
    path: "/my-space/performance-evaluation-add",
    key: "Add PE Form",
    component: AddPEForm,
    isPrivate: true,
    exact: true,
  },
  {
    path: "/my-space/performance-evaluation-list",
    key: "PE List",
    component: PerformanceEvaluationList,
    isPrivate: true,
    exact: true,
  },

  {
    path: "/things-to-do",
    key: "Things To Do",
    component: ThinksToDo,
    isPrivate: true,
    exact: true,
  },
  {
    path: "/things-to-do/interview-list",
    key: "Things To Do List",
    component: InterviewAndApprovalPendingList,
    isPrivate: true,
    exact: true,
  },
  {
    path: "/hrms",
    key: "HRMS",
    component: HMRMS,
    isPrivate: true,
    exact: true,
  },
  {
    path: "/hrms/recruitment-module",
    key: "Recruitment Module",
    component: RecruitmentModule,
    isPrivate: true,
    exact: true,
  },
  {
    path: "/hrms/check-in-reports",
    key: "All Users Check-Ins Reports",
    component: AllUsersCheckInsReports,
    isPrivate: true,
    exact: true,
  },
  {
    path: "/hrms/performance-evaluation-report",
    key: "All Users Performance Evaluation Report",
    component: AllUserPerformanceEvaluationReport,
    isPrivate: true,
    exact: true,
  },

  {
    path: "/hrms/leave-history-report",
    key: "All User's Leave History",
    component: AllUsersLeaveHistoryReport,
    isPrivate: true,
    exact: true,
  },
  {
    path: "/hrms/rating-report",
    key: "All User's Rating Report",
    component: AllUsersRatingReport,
    isPrivate: true,
    exact: true,
  },
  {
    path: "/hrms/recruitment-module/open-position",
    key: "List Open Job Positions",
    component: OpenPosition,
    isPrivate: true,
    exact: true,
  },

  {
    path: "/hrms/recruitment-module/hiring-checklist",
    key: "Hiring Check List",
    component: HiringCheckList,
    isPrivate: true,
    exact: true,
  },

  {
    path: "/hrms/recruitment-module/recruitment-tracker",
    key: "Recruitment Tracker List",
    component: RecruitmentTracker,
    isPrivate: true,
    exact: true,
  },

  {
    path: "/hrms/recruitment-module/recruitment-tracker/bulk-upload",
    key: "Recruitment Tracker Bulk Upload",
    component: RecruitmentTrackerBulkUpload,
    isPrivate: true,
    exact: true,
  },
  {
    path: "/hrms/recruitment-module/recruitment-tracker/add",
    key: "Add Recruitment Tracker",
    component: AddRecruitmentTracker,
    isPrivate: true,
    exact: true,
  },
  {
    path: "/hrms/recruitment-module/recruitment-tracker/edit",
    key: "Edit Recruitment Tracker",
    component: EditRecruitmentTracker,
    isPrivate: true,
    exact: true,
  },
  {
    path: "/hrms/hr-dashboard",
    key: "HR Dashboard",
    component: HRDashboard,
    isPrivate: true,
    exact: true,
  },
  {
    path: "/fixed-asset-register/bulk-upload/:id",
    key: "Bulk Fixed Asset",
    component: FixedAssetBulkUpload,
    isPrivate: true,
    exact: true,
  },
  {
    path: "/fixed-asset-register/fixed-asset-register-list/:id/add",
    key: "Add Fixed Asset Register",
    component: AddEditFixedAssetRegister,
    isPrivate: true,
    exact: true,
  },
  {
    path: "/fixed-asset-register/fixed-asset-register-list/:id/edit/:id",
    key: "Edit Fixed Asset Register",
    component: AddEditFixedAssetRegister,
    isPrivate: true,
    exact: true,
  },
  {
    path: "/fixed-asset-register/fixed-asset-register-list/:id",
    key: "Fixed Asset Register",
    component: FixedAssetRegisterList,
    isPrivate: true,
    exact: true,
  },
  {
    path: "/fixed-asset-register/:id",
    key: "Fixed Asset Register",
    component: FixedAssetRegister,
    isPrivate: true,
    exact: true,
  },
  {
    path: "/fixed-asset-register/physical-verification/:id",
    key: "Physical Verification",
    component: PhysicalVerification,
    isPrivate: true,
    exact: true,
  },
  {
    path: "/fixed-asset-register/:clientcode/physical-verification/:id",
    key: "Physical Verification Identity",
    component: PhysicalVerificationIdentity,
    isPrivate: true,
    exact: true,
  },
  {
    path: "/fixed-asset-register/audit-session/:id",
    key: "Audit Session",
    component: AuditSession,
    isPrivate: true,
    exact: true,
  },
  {
    path: "/fixed-asset-register/audit-session/:id/add",
    key: "Add Audit Session",
    component: AddAuditSession,
    isPrivate: true,
    exact: true,
  },
  {
    path: "/fixed-asset-register/audit-session/:id/edit/:id",
    key: "Edit Audit Session",
    component: AddAuditSession,
    isPrivate: true,
    exact: true,
  },
  {
    path: "/compliance-calendar",
    key: "compliance-calendar",
    component: ComplianceCalendar,
    isPrivate: true,
    exact: true,
  },
  {
    path: "/jobs",
    key: "jobs",
    component: Jobs,
    isPrivate: true,
    exact: true,
  },
  {
    path: "/jobs/jobs-type",
    key: "jobs-type",
    component: JobsType,
    isPrivate: true,
    exact: true,
  },
  {
    path: "/jobs/jobs-list",
    key: "jobs-list",
    component: JobsList,
    isPrivate: true,
    exact: true,
  },

  {
    path: "/jobs/recurring-jobs-report",
    key: "Recurring Job report",
    component: RecurringJobReport,
    isPrivate: true,
    exact: true,
  },

  {
    path: "/jobs/jobs-type/checklist",
    key: "jobs-checklist",
    component: JobChecklist,
    isPrivate: true,
    exact: true,
  },
  {
    path: "/jobs/jobs-type/checklist/add",
    key: "jobs-checklist-add",
    component: AddJobChecklist,
    isPrivate: true,
    exact: true,
  },
  {
    path: "/jobs/jobs-type/checklist/edit",
    key: "jobs-checklist-edit",
    component: EditJobChecklist,
    isPrivate: true,
    exact: true,
  },
  {
    path: "/all-open-jobs/checklist/:checklist_id/:job_id",
    key: "all-open-job-checklist",
    component: AllOpenJobChecklist,
    isPrivate: true,
    exact: true,
  },
  {
    path: "/jobs/recurring-jobs/add",
    key: "jobs-type",
    component: AddRecurringJobsSetting,
    isPrivate: true,
    exact: true,
  },
  {
    path: "/jobs/recurring-jobs/edit/:client_code",
    key: "jobs-type",
    component: EditRecurringJobsSetting,
    isPrivate: true,
    exact: true,
  },
  {
    path: "/jobs/recurring-jobs",
    key: "jobs-type",
    component: RecurringJobsSetting,
    isPrivate: true,
    exact: true,
  },
  {
    path: "/jobs/jobs-list/create-jobs-type",
    key: "create-jobs-type",
    component: AddJobType,
    isPrivate: true,
    exact: true,
  },
  {
    path: "/jobs/jobs-list/create-jobs",
    key: "create-jobs",
    component: AddJobs,
    isPrivate: true,
    exact: true,
  },
  {
    path: "/jobs/jobs-list/edit-jobs/:jobId",
    key: "edit-jobs",
    component: EditJobs,
    isPrivate: true,
    exact: true,
  },
  {
    path: "/jobs/jobs-type/edit/:jobId",
    key: "edit-jobs-type",
    component: EditJobType,
    isPrivate: true,
    exact: true,
  },
  {
    path: "/gst/:id",
    key: "gst",
    component: GSTModule,
    isPrivate: true,
    exact: true,
  },
  {
    path: "/gst/gstr-one/:id",
    key: "gstr-one",
    component: GstrOne,
    isPrivate: true,
    exact: true,
  },
  {
    path: "/gst/gstr-one/:id/filing",
    key: "gstr-one-filing",
    component: GstOneFiling,
    isPrivate: true,
    exact: true,
  },
  {
    path: "/gst/gstr-threeB/:id/filing",
    key: "gstr-theeB-filing",
    component: GstThreeBFiling,
    isPrivate: true,
    exact: true,
  },
  {
    path: "/master-data",
    key: "MasterData",
    component: MasterData,
    isPrivate: true,
    exact: true,
  },
  {
    path: "/master-data/branch",
    key: "Branch",
    component: Branch,
    isPrivate: true,
    exact: true,
  },
  {
    path: "/master-data/client-group",
    key: "Client Group",
    component: ClientGroup,
    isPrivate: true,
    exact: true,
  },
  {
    path: "/master-data/email",
    key: "Email",
    component: Email,
    isPrivate: true,
    exact: true,
  },
  {
    path: "/master-data/holiday-calender",
    key: "Holiday Calender",
    component: HolidayCalender,
    isPrivate: true,
    exact: true,
  },
  {
    path: "/master-data/currency",
    key: "Currency",
    component: Currency,
    isPrivate: true,
    exact: true,
  },
  {
    path: "/master-data/activity-code",
    key: "Activity Code ",
    component: ActivityCode,
    isPrivate: true,
    exact: true,
  },

  {
    path: "/master-data/client-category",
    key: "Client Category",
    component: ClientCategory,
    isPrivate: true,
    exact: true,
  },
  {
    path: "/master-data/user-department",
    key: "Users Department",
    component: UsersDepartment,
    isPrivate: true,
    exact: true,
  },
  {
    path: "/master-data/job-title",
    key: "Job Title",
    component: JobTitle,
    isPrivate: true,
    exact: true,
  },
  {
    path: "/master-data/tds-and-tcs-master",
    key: "TDS And TCS Master",
    component: TdsAndTcsMaster,
    isPrivate: true,
    exact: true,
  },
  {
    path: "/master-data/tds-and-tcs-master/add-tds",
    key: "Add TDS Master",
    component: AddTdsMaster,
    isPrivate: true,
    exact: true,
  },
  {
    path: "/master-data/tds-and-tcs-master/edit-tds/:tdsId",
    key: "Edit TDS Master",
    component: EditTdsMaster,
    isPrivate: true,
    exact: true,
  },
  // tcs
  {
    path: "/master-data/tds-and-tcs-master/add-tcs",
    key: "Add TCS Master",
    component: AddTcsMaster,
    isPrivate: true,
    exact: true,
  },
  {
    path: "/master-data/tds-and-tcs-master/edit-tcs/:tcsId",
    key: "Edit TCS Master",
    component: EditTcsMaster,
    isPrivate: true,
    exact: true,
  },

  {
    path: "/master-data/skills-and-qualifications",
    key: "Skills And Qualification",
    component: SkillsAndQualification,
    isPrivate: true,
    exact: true,
  },
  {
    path: "/master-data/scope-of-work",
    key: "Scope Of Work",
    component: ScopeOfWork,
    isPrivate: true,
    exact: true,
  },
  {
    path: "/gst/gstr-threeB/:id",
    key: "Gstr ThreeB",
    component: GstrThreeB,
    isPrivate: true,
    exact: true,
  },
  {
    path: "/dashboard",
    key: "Dashboard",
    component: "",
    isPrivate: true,
    exact: true,
  },
  {
    path: "/services/ifsc",
    key: "IFSC",
    component: IFSC,
    isPrivate: true,
    exact: true,
  },
  {
    path: "/services/pan-aadhar-link",
    key: "PanAadharLink",
    component: PanAadharLink,
    isPrivate: true,
    exact: true,
  },
  {
    path: "/services/gst-info",
    key: "GST",
    component: GstInfo,
    isPrivate: true,
    exact: true,
  },
  {
    path: "/services/bank-account-info",
    key: "BankAccountInfo",
    component: BankAccountInfo,
    isPrivate: true,
    exact: true,
  },
  {
    path: "/services/verify-pan",
    key: "PanVerify",
    component: PanVerify,
    isPrivate: true,
    exact: true,
  },
  // {
  //   path: "/services/verify-tan",
  //   key: "TanVerify",
  //   component: TanVerify,
  //   isPrivate: true,
  //   exact: true,
  // },
  {
    path: "/services",
    key: "Services",
    component: Services,
    isPrivate: true,
    exact: true,
  },
  {
    path: "/time-sheet",
    key: "Time Sheet",
    component: TimeSheet,
    isPrivate: true,
    exact: true,
  },
  {
    path: "/time-sheet-reports",
    key: "Timesheet Reports",
    component: TimeSheetReports,
    isPrivate: true,
    exact: true,
  },
  {
    path: "/time-sheet-reports/time-sheet-admin-reports",
    key: "Timesheet Admin Reports",
    component: TimeSheetAdminReport,
    isPrivate: true,
    exact: true,
  },
  {
    path: "/time-sheet-reports/time-sheet-summary-reports",
    key: "Timesheet Summary Reports",
    component: TimSheetSummaryReport,
    isPrivate: true,
    exact: true,
  },
  {
    path: "/client-dashboard/:id",
    key: "ClientDashboard",
    component: ClientDashboard,
    isPrivate: true,
    exact: true,
  },
  {
    path: "/reports/:id",
    key: "Reports",
    component: Reports,
    isPrivate: true,
    exact: true,
  },
  {
    path: "/reports/:id/ledger-statement",
    key: "Ledger Statement",
    component: LedgerStatement,
    isPrivate: true,
    exact: true,
  },
  {
    path: "/reports/:id/trial-balance",
    key: "Trial Balance",
    component: TrialBalance,
    isPrivate: true,
    exact: true,
  },
  {
    path: "/reports/:id/detailed-trial-balance",
    key: "Detailed Trial Balance",
    component: DetailedTrialBalance,
    isPrivate: true,
    exact: true,
  },
  {
    path: "/reports/:id/profit-loss",
    key: "Profit Loss",
    component: ProfitLoss,
    isPrivate: true,
    exact: true,
  },
  {
    path: "/reports/:id/detailed-profit-loss",
    key: "Detailed Profit Loss",
    component: DetailedProfitLoss,
    isPrivate: true,
    exact: true,
  },
  {
    path: "/reports/:id/balance-sheet",
    key: "Balance Sheet",
    component: BalanceSheet,
    isPrivate: true,
    exact: true,
  },
  {
    path: "/reports/:id/day-book",
    key: "Day Book",
    component: DayBook,
    isPrivate: true,
    exact: true,
  },
  {
    path: "/reports/:id/ageing-analysis",
    key: "Ageing Analysis Report",
    component: AgeingAnalysisReport,
    isPrivate: true,
    exact: true,
  },
  {
    path: "/reports/:id/general-ledger",
    key: "General Legder",
    component: GeneralLedger,
    isPrivate: true,
    exact: true,
  },
  {
    path: "/reports/:id/detailed-balance-sheet",
    key: "Balance Sheet",
    component: DetailedBalanceSheet,
    isPrivate: true,
    exact: true,
  },
  {
    path: "/reports/:id/receipt-&-payment-account",
    key: "receipt and payment",
    component: ReceiptAndPayment,
    isPrivate: true,
    exact: true,
  },
  {
    path: "/reports/:id/monthly-ledger-summary",
    key: "Monthly Ledger Summary",
    component: MonthlyLedgerSummary,
    isPrivate: true,
    exact: true,
  },
  {
    path: "/reports/:id/stock-report-summary",
    key: "Stock Report Summary",
    component: StockReportSummary,
    isPrivate: true,
    exact: true,
  },
  {
    path: "/reports/:id/stock-statement",
    key: "Stock Statement",
    component: StockStatement,
    isPrivate: true,
    exact: true,
  },
  {
    path: "/reports/:id/stock-limit",
    key: "Stock Limit",
    component: StockLimits,
    isPrivate: true,
    exact: true,
  },
  {
    path: "/reports/:id/batch-summary",
    key: "Batch Summary",
    component: BatchSummaryReport,
    isPrivate: true,
    exact: true,
  },
  {
    path: "/reports/:id/batch-voucher",
    key: "Batch Voucher",
    component: BatchVoucherReport,
    isPrivate: true,
    exact: true,
  },
  {
    path: "/reports/:id/trading-profit-loss",
    key: "Trading, Profit & loss",
    component: CostOfGoods,
    isPrivate: true,
    exact: true,
  },
  {
    path: "/client-settings/addresses/:id",
    key: "Address Manager",
    component: AddressManager,
    isPrivate: true,
    exact: true,
  },
  {
    path: "/client-settings/addresses/add/:id",
    key: "Add Business Address",
    component: AddBusinessAddress,
    isPrivate: true,
    exact: true,
  },
  {
    path: "/client-settings/addresses/edit/:id",
    key: "Edit Business Address",
    component: EditBusinessAddress,
    isPrivate: true,
    exact: true,
  },
  {
    path: "/client-settings/accounts-manager/:id",
    key: "Accounts Manager",
    component: AccountsManager,
    isPrivate: true,
    exact: true,
  },
  {
    path: "/client-settings/manufacturing-saved-template/:id",
    key: "BOM Saved Template",
    component: BOMSavedTemplate,
    isPrivate: true,
    exact: true,
  },
  {
    path: "/client-settings/stock-manager/:id",
    key: "Stock Manager",
    component: StockManager,
    isPrivate: true,
    exact: true,
  },
  {
    path: "/client-settings/stock-manager/stock-groups-list/:id",
    key: "Stock Groups",
    component: StockGroupsList,
    isPrivate: true,
    exact: true,
  },
  {
    path: "/client-settings/stock-manager/stock-items-list/:id",
    key: "Stock Items",
    component: StockItemsList,
    isPrivate: true,
    exact: true,
  },
  {
    path: "/client-settings/stock-manager/stock-items-list/add-stock-item/:id",
    key: "Add Stock Items",
    component: AddStockItem,
    isPrivate: true,
    exact: true,
  },
  {
    path: "/client-settings/stock-manager/stock-items-list/edit-stock-item/:id",
    key: "Edit Stock Items",
    component: EditStockItemList,
    isPrivate: true,
    exact: true,
  },
  {
    path: "/client-settings/stock-manager/stock-items-list/bulk-upload/:id",
    key: "Bulk Upload Stock Items",
    component: StockItemBulkUpload,
    isPrivate: true,
    exact: true,
  },
  {
    path: "/client-settings/stock-manager/units-of-measurement/:id",
    key: "Units Of Measurement",
    component: UnitsOfMeasurement,
    isPrivate: true,
    exact: true,
  },
  {
    path: "/client-settings/customers-suppliers/:id",
    key: "Customer/Supplier",
    component: CustomerSupplierManager,
    isPrivate: true,
    exact: true,
  },
  {
    path: "/client-settings/customers-suppliers/bulk-upload/:id",
    key: "Bulk Upload Customer/Supplier",
    component: CustomerSupplierBulkUpload,
    isPrivate: true,
    exact: true,
  },
  {
    path: "/client-settings/department/:id",
    key: "Department",
    component: Department,
    isPrivate: true,
    exact: true,
  },

  {
    path: "/client-settings/batch-management/:id",
    key: "Batch Management",
    component: BatchManagement,
    isPrivate: true,
    exact: true,
  },
  {
    path: "/client-settings/batch-management/:id/add",
    key: "Add Batch management",
    component: AddBatchManagement,
    isPrivate: true,
    exact: true,
  },
  {
    path: "/client-settings/batch-management/:id/edit/:id",
    key: "Edit Batch management",
    component: EditBatchManagement,
    isPrivate: true,
    exact: true,
  },
  {
    path: "/client-settings/customers-suppliers/add/:id",
    key: "Add Customer/Supplier",
    component: AddCustomerSupplier,
    isPrivate: true,
    exact: true,
  },
  {
    path: "/client-settings/customers-suppliers/edit/:id/:address_id",
    key: "Edit Customer/Supplier",
    component: EditCustomerSupplier,
    isPrivate: true,
    exact: true,
  },
  {
    path: "/client-id-password-manager/:id",
    key: "Client IdPasswordManager List",
    component: ClientIdPasswordManagerList,
    isPrivate: true,
    exact: true,
  },
  {
    path: "/sops/:id",
    key: "SOP Module List",
    component: SopModule,
    isPrivate: true,
    exact: true,
  },
  {
    path: "/sops/:id/edit/:id",
    key: "Edit SOP Module",
    component: EditSopModule,
    isPrivate: true,
    exact: true,
  },
  {
    path: "/sops/:id/add",
    key: "Add SOP Module",
    component: AddSopModule,
    isPrivate: true,
    exact: true,
  },
  {
    path: "/client-id-password-manager/add/:id",
    key: "Client AddIdPasswordManager",
    component: AddIClientIdPasswordManager,
    isPrivate: true,
    exact: true,
  },
  {
    path: "/client-id-password-manager/edit/:id",
    key: "Client EditIdPasswordManager",
    component: EditClientIdPasswordManager,
    isPrivate: true,
    exact: true,
  },
  {
    path: "/client-settings/:id",
    key: "Client Settings",
    component: ClientSettings,
    isPrivate: true,
    exact: true,
  },
  {
    path: "/job-tracker-list/:id",
    key: "JobTrackerListing",
    component: JobTrackerListing,
    isPrivate: true,
    exact: true,
  },
  {
    path: "/forgot-password",
    key: "ForgotPassword",
    component: ForgotPassword,
    isPrivate: false,
    exact: true,
  },
  {
    path: "/reset-password",
    key: "ResetForgetPassword",
    component: ResetForgetPassword,
    isPrivate: false,
    exact: true,
  },
  {
    path: "/login",
    key: "Login",
    component: Login,
    isPrivate: false,
    exact: true,
  },
  {
    path: "/signup",
    key: "Signup",
    component: SignUp,
    isPrivate: false,
    exact: true,
  },
  {
    path: "/au-bank-signup",
    key: "AuSignup",
    component: AuSignUp,
    isPrivate: false,
    exact: true,
  },
  // {
  //   path: "/profile",
  //   key: "Profile",
  //   component: UserProfile,
  //   isPrivate: true,
  //   exact: true,
  // },
  {
    path: "/settings",
    key: "Settings",
    component: Settings,
    isPrivate: true,
    exact: true,
  },
  {
    path: "/my-space",
    key: "My Space",
    component: MySpace,
    isPrivate: true,
    exact: true,
  },
  {
    path: "/my-space/my-in-and-out-report",
    key: "My Space My In And Out Attendance Report",
    component: LoggedInUsersAttendanceReport,
    isPrivate: true,
    exact: true,
  },
  {
    path: "/my-space/user-profile/:profile_id",
    key: "My Space User Profile",
    component: LoggedInUserProfileDetails,
    isPrivate: true,
    exact: true,
  },
  {
    path: "/my-space/all-leaves-and-work-from-home",
    key: "My Space All Leaves And WFH",
    component: AllLeavesAndWHF,
    isPrivate: true,
    exact: true,
  },
  {
    path: "/my-space/pending-leaves",
    key: "My Space pending Leaves",
    component: ApprovedAndPendingLeaves,
    isPrivate: true,
    exact: true,
  },
  {
    path: "/my-space/pending-wfh",
    key: "My Space pending wfh",
    component: ApprovedAndPendingWFH,
    isPrivate: true,
    exact: true,
  },
  {
    path: "/my-space/pending-leaves/pending-leaves-details/:uniqueId",
    key: "My Space Pending Leaves Details",
    component: LeaveAndWFHDetails,
    isPrivate: true,
    exact: true,
  },
  {
    path: "/my-space/pending-wfh/pending-wfh-details/:uniqueId",
    key: "My Space Pending WFH Details",
    component: LeaveAndWFHDetails,
    isPrivate: true,
    exact: true,
  },
  {
    path: "/support",
    key: "Support",
    component: SupportPage,
    isPrivate: true,
    exact: true,
  },
  {
    path: "/my-space/check-in-list",
    key: "Check-In Schedule List",
    component: CheckInScheduleList,
    isPrivate: true,
    exact: true,
  },
  {
    path: "/all-users",
    key: "User",
    component: AllUsersAndClients,
    isPrivate: true,
    exact: true,
  },
  {
    path: "/all-users/add-external-user",
    key: "ExternalUsers",
    component: AddInternalExternalUser,
    isPrivate: true,
    exact: true,
  },
  {
    path: "/client-directory-list",
    key: "ClientDirectory List",
    component: ClientDirectory,
    isPrivate: true,
    exact: true,
  },
  {
    path: "/assigned-client-directory",
    key: "Assigned ClientDirectory List View",
    component: ClientDirectory,
    isPrivate: true,
    exact: true,
  },
  {
    path: "/expense-management",
    key: "ExpenseManagement",
    component: ExpenseManagement,
    isPrivate: true,
    exact: true,
  },
  {
    path: "/expense-management/raise-expense",
    key: "RaiseExpense",
    component: RaiseExpenseHome,
    isPrivate: true,
    exact: true,
  },
  {
    path: "/expense-management/approve-expenses",
    key: "ApproveExpenses",
    component: ApproveExepnseHome,
    isPrivate: true,
    exact: true,
  },
  {
    path: "/client-directory-list/add",
    key: "addClient",
    component: AddClient,
    isPrivate: true,
    exact: true,
  },
  {
    path: "/client-directory-list/edit/:client_id",
    key: "editClient",
    component: EditClient,
    isPrivate: true,
    exact: true,
  },
  {
    path: "/assigned-client-directory/view/:client_id",
    key: "Assigned ClientDirectory View",
    component: ViewClient,
    isPrivate: true,
    exact: true,
  },
  {
    path: "/all-users/add-internal-user",
    key: "InternalUsers",
    component: AddInternalExternalUser,
    isPrivate: true,
    exact: true,
  },
  {
    path: "/all-users/:type/:user_id",
    key: "User",
    component: EditInternalExternalUser,
    isPrivate: true,
    exact: true,
  },
  {
    path: "/assign-columns",
    key: "AssignColumns",
    component: AssignColumns,
    isPrivate: true,
    exact: true,
  },
  {
    path: "/assign-invoice-columns",
    key: "AssignColumnsNew",
    component: AssignColumnsNew,
    isPrivate: true,
    exact: true,
  },
  {
    path: "/assign-clients",
    key: "AssignClients",
    component: AssignClients,
    isPrivate: true,
    exact: true,
  },
  {
    path: "/user-management",
    key: "UserManagement",
    component: UserManagement,
    isPrivate: true,
    exact: true,
  },
  {
    path: "/user-management/user-groups",
    key: "UserGroups",
    component: UserGroups,
    isPrivate: true,
    exact: true,
  },
  {
    path: "/user-management/user-groups/add-user-group",
    key: "AddEditUserGroup",
    component: AddEditUserGroup,
    isPrivate: true,
    exact: true,
  },
  {
    path: "/user-management/user-groups/edit-user-group/:group_id",
    key: "AddEditUserGroup",
    component: AddEditUserGroup,
    isPrivate: true,
    exact: true,
  },
  {
    path: "/user-management/assign-groups-list",
    key: "AssignGroupToUserList",
    component: AssignGroupsList,
    isPrivate: true,
    exact: true,
  },
  {
    path: "/user-management/assign-groups-list/assign-groups",
    key: "AssignGroupToUser",
    component: AssignGroupToUser,
    isPrivate: true,
    exact: true,
  },
  {
    path: "/user-management/menu-list",
    key: "AddEditMenuList",
    component: AddEditMenuList,
    isPrivate: true,
    exact: true,
  },
  {
    path: "/id-password-manager",
    key: "ID Password Manager List",
    component: IdPasswordManagerList,
    isPrivate: true,
    exact: true,
  },
  {
    path: "/id-password-manager/add",
    key: "AddIdPasswordManager",
    component: AddIdPasswordManager,
    isPrivate: true,
    exact: true,
  },
  {
    path: "/id-password-manager/edit",
    key: "EditIdPasswordManager",
    component: EditIdPasswordManager,
    isPrivate: true,
    exact: true,
  },
  {
    path: "/disbursement-module",
    key: "Disbursements List",
    component: DisbursementModuleList,
    isPrivate: true,
    exact: true,
  },
  {
    path: "/disbursement-module/add",
    key: "AddDisbursementModule",
    component: AddDisbursement,
    isPrivate: true,
    exact: true,
  },
  {
    path: "/disbursement-module/edit",
    key: "EditDisbursementModule",
    component: EditDisbursement,
    isPrivate: true,
    exact: true,
  },
  {
    path: "/change-credentials",
    key: "ChangeClientCredentials",
    component: ChangeClientPassword,
    isPrivate: true,
    exact: true,
  },
  {
    path: "/invoice/:id",
    key: "InvoiceOptions",
    component: InvoiceListings,
    isPrivate: true,
    exact: true,
  },
  {
    path: "/invoice-generation/:id",
    key: "InvoiceGeneration",
    component: InvoiceGenerationList,
    isPrivate: true,
    exact: true,
  },
  {
    path: "/invoice-generation/e-invoice/:id",
    key: "eInvoice",
    component: Einvoice,
    isPrivate: true,
    exact: true,
  },
  {
    path: "/invoice-generation/e-way-bill/:id",
    key: "eWayBill",
    component: EwayBill,
    isPrivate: true,
    exact: true,
  },
  {
    path: "/invoice-generation/add/:id",
    key: "InvoiceGeneration",
    component: InvoiceGenerationAdd,
    isPrivate: true,
    exact: true,
  },
  {
    path: "/invoice-generation/add-ocr/:id",
    key: "InvoiceGenerationOcr",
    component: AddOcrInvoice,
    isPrivate: true,
    exact: true,
  },
  {
    path: "/invoice-generation/add-gst-compare/:id",
    key: "InvoiceGenerationGstCompare",
    component: AddGstCompareInvoice,
    isPrivate: true,
    exact: true,
  },
  {
    path: "/invoice-generation/edit/:invoice_id/:id/",
    key: "InvoiceGeneration",
    component: InvoiceGenerationEditInvoice,
    isPrivate: true,
    exact: true,
  },
  {
    path: "/invoice-generation/copy/:invoice_id/:id/",
    key: "InvoiceGenerationCopy",
    component: CopyInvoice,
    isPrivate: true,
    exact: true,
  },
  {
    path: "/invoice-generation/add-others/:id",
    key: "AddEditOtherEntryInvoice",
    component: AddEditOtherEntryInvoice,
    isPrivate: true,
    exact: true,
  },
  {
    path: "/invoice-generation/add-manufacturing/:id",
    key: "addBillOfMaterial",
    component: AddBillOfMaterial,
    isPrivate: true,
    exact: true,
  },
  {
    path: "/invoice-generation/edit-manufacturing/:id/",
    key: "editBillOfMaterial",
    component: EditBillOfMaterial,
    isPrivate: true,
    exact: true,
  },
  {
    path: "/invoice-generation/edit-others/:id/:invoice_id",
    key: "AddEditOtherEntryInvoice",
    component: AddEditOtherEntryInvoice,
    isPrivate: true,
    exact: true,
  },
  {
    path: "/invoice-generation/copy-others/:id/:invoice_id",
    key: "CopyOtherEntryInvoice",
    component: OtherCopyInvoice,
    isPrivate: true,
    exact: true,
  },
  {
    path: "/invoice-generation/bulk-upload/:id",
    key: "InvoiceBulkUpload",
    component: InvoiceBulkUpload,
    isPrivate: true,
    exact: true,
  },
  {
    path: "/invoice/bulk-upload/:id",
    key: "BulkUpload",
    component: BulkUpload,
    isPrivate: true,
    exact: true,
  },
  {
    path: "/documents/list/:id",
    key: "DocumentList",
    component: DocumentList,
    isPrivate: true,
    exact: true,
  },
  {
    path: "/open-items-client/:id",
    key: "OpenItems",
    component: ClientOpenItemsList,
    isPrivate: true,
    exact: true,
  },
  {
    path: "/open-items-client/:id/view/:job_id",
    key: "OpenItems",
    component: ClientViewOpenItem,
    isPrivate: true,
    exact: true,
  },
  {
    path: "/open-items-admin/add",
    key: "OpenItems",
    component: AdminOpenItemAdd,
    isPrivate: true,
    exact: true,
  },
  {
    path: "/open-items-admin/edit/:itemId",
    key: "OpenItems",
    component: AdminOpenItemEdit,
    isPrivate: true,
    exact: true,
  },
  {
    path: "/open-items-admin/summary/:itemId",
    key: "OpenItems",
    component: AdminOpenItemSummary,
    isPrivate: true,
    exact: true,
  },
  {
    path: "/open-items-admin",
    key: "Open Items",
    component: AdminOpenItemsList,
    isPrivate: true,
    exact: true,
  },
  {
    path: "/file-manager/:id/folder/:folder_id",
    key: "FileManager",
    component: FileManager,
    isPrivate: true,
    exact: true,
  },
  {
    path: "/file-managers/:id/search=:data",
    key: "FileManagerSearch",
    component: SearchFileManager,
    isPrivate: true,
    exact: true,
  },
  {
    path: "/invoice/add-invoice/:id",
    key: "AddInvoice",
    component: AddInvoice,
    isPrivate: true,
    exact: true,
  },
  {
    path: "/invoice/edit-invoice/:id",
    key: "EditInvoice",
    component: EditInvoice,
    isPrivate: true,
    exact: true,
  },
  {
    path: "/insights/:id",
    key: "Insights",
    component: InsightsDashboard,
    isPrivate: true,
    exact: true,
  },
  {
    path: "/insights/:id/invoice-graph",
    key: "Insights",
    component: InvoiceDetail,
    isPrivate: true,
    exact: true,
  },
  {
    path: "/insights-advanced-summary/:id",
    key: "InsightsSummary",
    component: InsightSummary,
    isPrivate: true,
    exact: true,
  },
  {
    path: "/insights-advanced-summary/profit-loss/:id",
    key: "Insights",
    component: InsightsAdvacedList,
    isPrivate: true,
    exact: true,
  },
  {
    path: "/admin-reports",
    key: "Admin Reports",
    component: AdminReports,
    isPrivate: true,
    exact: true,
  },
  {
    path: "/admin-reports/job-progress",
    key: "Job Progress",
    component: JobProgressReports,
    isPrivate: true,
    exact: true,
  },
  {
    path: "/admin-reports/all-eway-bills",
    key: "All E-Way Bills",
    component: AllEwayBillList,
    isPrivate: true,
    exact: true,
  },
  {
    path: "/admin-reports/all-e-invoices",
    key: "All E-Invoices",
    component: AllEInvoiceList,
    isPrivate: true,
    exact: true,
  },
  {
    path: "/admin-reports/all-open-items",
    key: "OpenItemsProgressReports",
    component: OpenItemsProgressReports,
    isPrivate: true,
    exact: true,
  },
  {
    path: "/admin-reports/all-open-items/all-open-items-view/:openItemId",
    key: "ViewOpenItemsProgressReports",
    component: ViewOpenItemsProgressReports,
    isPrivate: true,
    exact: true,
  },
  {
    path: "/admin-reports/file-folder-count",
    key: "File Folder Count",
    component: FileFolderCounterReports,
    isPrivate: true,
    exact: true,
  },

  {
    path: "/admin-reports/invoicing-report",
    key: "Invoice Reports",
    component: InvoiceReports,
    isPrivate: true,
    exact: true,
  },
  {
    path: "/admin-reports/invoicing-report/invoicing-count",
    key: "invoicingCount",
    component: InvoicingAdvanceCounts,
    isPrivate: true,
    exact: true,
  },
  {
    path: "/admin-reports/invoicing-report/user-invoice-count",
    key: "User Invoice Count",
    component: UsersInvoicingCount,
    isPrivate: true,
    exact: true,
  },
  {
    path: "/admin-reports/assign-users",
    key: "assignedUsersOfClient",
    component: AssignedUsersOfClient,
    isPrivate: true,
    exact: true,
  },
  {
    path: "/admin-reports/user-login-session-reports",
    key: "User Login Session Report",
    component: UserLoginSessionReport,
    isPrivate: true,
    exact: true,
  },
  {
    path: "/admin-reports/user-login-session-reports/daily-active",
    key: "Daily Active Users",
    component: DailyActiveUser,
    isPrivate: true,
    exact: true,
  },
  {
    path: "/admin-reports/user-login-session-reports/monthly-active",
    key: "Monthly Active Users",
    component: MonthlyActiveUser,
    isPrivate: true,
    exact: true,
  },
  {
    path: "/admin-reports/user-login-session-reports/session-login-count",
    key: "Session Login Count",
    component: UserSessionLoginCount,
    isPrivate: true,
    exact: true,
  },
  {
    path: "/admin-reports/user-login-session-reports/user-report",
    key: "User Report",
    component: UserReport,
    isPrivate: true,
    exact: true,
  },
  {
    path: "/admin-reports/sops",
    key: "All Clients Sop",
    component: AllClientSop,
    isPrivate: true,
    exact: true,
  },
  {
    path: "/all-open-jobs",
    key: "All Open Jobs",
    component: UserOpenJobsListing,
    isPrivate: true,
    exact: true,
  },
  {
    path: "/access-denied",
    key: "Unauthorize",
    component: Unauthorize,
    isPrivate: true,
    exact: true,
  },
  {
    path: "/schedule-maintenance",
    key: "Schedule Maintenance",
    component: ScheduleMaintenance,
    isPrivate: true,
    exact: true,
  },
  {
    path: "/lead-module",
    key: "Lead Module",
    component: LeadDirectory,
    isPrivate: true,
    exact: true,
  },
  {
    path: "/lead-module/client-meet-up-check-list",
    key: "Client Meet Up Checklist",
    component: ClientMeetUp,
    isPrivate: true,
    exact: true,
  },
  {
    path: "/lead-module/client-meet-up-check-list/edit",
    key: "Edit Meet Up Checklist",
    component: EditClientMeetUp,
    isPrivate: true,
    exact: true,
  },
  {
    path: "/lead-module/all-client-meet-up-status",
    key: "All Client Meet Up Status",
    component: AllClientMeetUpStatus,
    isPrivate: true,
    exact: true,
  },
  //
  {
    path: "/lead-module/lead-directory-list",
    key: "Lead Module List",
    component: LeadModule,
    isPrivate: true,
    exact: true,
  },
  {
    path: "/lead-module/lead-directory-list/edit/:leadId",
    key: "Edit Lead Module",
    component: EditLeadModule,
    isPrivate: true,
    exact: true,
  },
  {
    path: "/lead-module/stage-threshold-master",
    key: "Lead Module Stage Threshold Master",
    component: LeadModuleStageThresholdMaster,
    isPrivate: true,
    exact: true,
  },
  {
    path: "/help-module-list",
    key: "Help Module List",
    component: HelpModule,
    isPrivate: true,
    exact: true,
  },
  {
    path: "/client-meet-up",
    key: "Client Meet up",
    component: ClientMeetUp,
    isPrivate: true,
    exact: true,
  },
  {
    path: "/scheduling",
    key: "Scheduling",
    component: Scheduling,
    isPrivate: true,
    exact: true,
  },
  {
    path: "/scheduling/user",
    key: "UserView",
    component: UserView,
    isPrivate: true,
    exact: true,
  },
  {
    path: "/scheduling/users",
    key: "Estimate User View",
    component: UserView,
    isPrivate: true,
    exact: true,
  },
  {
    path: "/scheduling/manager",
    key: "ManagerView",
    component: ManagerView,
    isPrivate: true,
    exact: true,
  },

  {
    path: "/scheduling/reports/client-user-scheduling",
    key: "Client VS User Scheduling",
    component: ClientVsUserScheduling,
    isPrivate: true,
    exact: true,
  },

  {
    path: "/scheduling/reports/client-job-scheduling",
    key: "Client Job Scheduling",
    component: ClientJobSchedule,
    isPrivate: true,
    exact: true,
  },

  {
    path: "/scheduling/reports/all-users",
    key: "All Users Schedule",
    component: AllUsersSchedule,
    isPrivate: true,
    exact: true,
  },
  {
    path: "/scheduling/reports/all-users-approval-pending",
    key: "All Users Approval Pending Schedule",
    component: AllUsersApprovalPendingList,
    isPrivate: true,
    exact: true,
  },
  {
    path: "/scheduling/reports/jobs-specific-users",
    key: "Job Specific User",
    component: JobSpecificUsersReport,
    isPrivate: true,
    exact: true,
  },
  {
    path: "/scheduling/reports/availability-report",
    key: "Availability Report",
    component: AvailabilityReport,
    isPrivate: true,
    exact: true,
  },
  {
    path: "/scheduling/reports/manager-client-scheduling",
    key: "Manager Client Scheduling",
    component: ManagerClientSchedule,
    isPrivate: true,
    exact: true,
  },
  {
    path: "/scheduling/reports/all-clients",
    key: "All Clients Schedule",
    component: AllClientsSchedule,
    isPrivate: true,
    exact: true,
  },
  {
    path: "/scheduling/reports",
    key: "Schedule Reports",
    component: SchedulingReports,
    isPrivate: true,
    exact: true,
  },
  {
    path: "/time-sheet-reports/attendace-all-users-reports",
    key: "All User Attendance Report",
    component: AllUserAttendanceReport,
    isPrivate: true,
    exact: true,
  },
  {
    path: "/time-sheet-reports/attendace-reports",
    key: "User Attendance Report",
    component: AttendanceReport,
    isPrivate: true,
    exact: true,
  },
  {
    path: "/time-sheet-reports/time-sheet-scheduling-monthly-reports",
    key: "Timesheet Scheduling Monthly Report",
    component: TimeSheetVsSchedulingMonthlyReport,
    isPrivate: true,
    exact: true,
  },
  {
    path: "/time-sheet-reports/client-wise-time-sheet-report",
    key: "Timesheet Client Wise User Reports",
    component: TimeSheetClientWiseUserReport,
    isPrivate: true,
    exact: true,
  },
  {
    path: "/time-sheet-reports/client-wise-monthly-report",
    key: "Timesheet Client Wise Monthly Reports",
    component: TimesheetClientWiseMonthlyReport,
    isPrivate: true,
    exact: true,
  },
  {
    path: "/time-sheet-reports/month-wise-client-report",
    key: "Timesheet Month Wise Client Reports",
    component: TimesheetMonthWiseClientReport,
    isPrivate: true,
    exact: true,
  },
  {
    path: "/scheduling/manager/view-request/:scheduling_id",
    key: "viewRequest",
    component: RequestView,
    isPrivate: true,
    exact: true,
  },
  {
    path: "/",
    key: "ROOT",
    component: Home,
    isPrivate: true,
    exact: true,
  },
];

export default ROUTES;

export function RenderRoutes({ routes, token }: AppProps) {
  const [toggle, setToggle] = useState(false);
  const handleToggle = () => {
    setToggle(!toggle);
  };
  return (
    <Switch>
      {routes.map((route: RoutesType, i: number) => {
        return route.isPrivate ? (
          <PrivateRoutes
            isLoggedIn={!!token}
            path={route.path}
            exact={route.exact}
            component={route.component}
            key={route.key}
            isPrivate={route.isPrivate}
            name={route.key}
            toggle={toggle}
            setToggle={setToggle}
            handleToggle={handleToggle}
          />
        ) : route.isPrivate === false ? (
          <PublicRoutes
            isLoggedIn={!!token}
            path={route.path}
            exact={route.exact}
            component={route.component}
            key={route.key}
            isPrivate={route.isPrivate}
            name={route.key}
          />
        ) : (
          <HybridRoute
            isLoggedIn={!!token}
            path={route.path}
            exact={route.exact}
            component={route.component}
            key={route.key}
            name={route.key}
          />
        );
      })}
      <Route component={() => <ErrorPage />} />
    </Switch>
  );
}
